
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_19237","data-name":"Path 19237","d":"M3.5.5h9a3 3 0 013 3h0a3 3 0 01-3 3h-9a3 3 0 01-3-3h0a3 3 0 013-3z","fill":"none","stroke":"#6b7786","stroke-width":"1"}}),_c('g',{attrs:{"id":"Group_18666","data-name":"Group 18666","transform":"translate(5.002 3.5)","fill":"#d3dae9","stroke":"#6b7786","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1"}},[_c('path',{attrs:{"id":"Path_849-5","data-name":"Path 849-5","d":"M686.369 362.425h-3.107","transform":"translate(-683.262 -362.425)"}}),_c('path',{attrs:{"id":"Path_849-5-2","data-name":"Path 849-5-2","d":"M689.451 362.425h-1.189","transform":"translate(-683.262 -362.425)"}})])])
          )
        }
      }
    